export enum HelpActionType {
  GET_HELP_REQUEST = 'HELP_REQUEST',
  GET_HELP_SUCCESS = 'GET_HELP_SUCCESS',
  GET_HELP_FAIL = 'GET_HELP_FAIL',
  TOGGLE_HELP = 'TOGGLE_HELP',
}
